(function () {
  'use strict';

  class FilterLifeTabs {
    /**
     * @param {HTMLElement} section - The section root with [data-filter-life-section]
     */
    constructor(section) {
      this.section = section;
      this.group = section.querySelector('.filter-life__blocks');
      this.tabs = this.group ? Array.from(this.group.querySelectorAll('[data-filter-life-tab]')) : [];
      this.panels = this.group ? Array.from(this.group.querySelectorAll('[data-filter-life-panel]')) : [];
    }

    init() {
      if (!this.group || this.tabs.length === 0) return;

      this._buildTabStrip();

      for (const tab of this.tabs) {
        tab.addEventListener('click', () => this.activateTab(tab));
        tab.addEventListener('keydown', (event) => this._handleKeydown(event));
      }

      // Take over from the pre-JS CSS fallback, which shows the first pill/panel.
      this._syncState(this.tabs[0]);
      this.group.setAttribute('data-ready', '');
    }

    /**
     * Moves the pills into their own flex line. _filter-tab has to emit each pill and
     * its panel as siblings, so without this the pills share the panels' wrapping
     * container and break onto a second row once they outgrow the viewport. The strip
     * keeps them on the single scrolling line the mobile design calls for; with JS off
     * the pills stay where they are and wrap, which is a fine fallback.
     */
    _buildTabStrip() {
      if (this.group.querySelector('.filter-life__tab-strip')) return;

      const strip = document.createElement('div');
      strip.className = 'filter-life__tab-strip';
      this.group.insertBefore(strip, this.group.firstChild);
      for (const tab of this.tabs) strip.appendChild(tab);
    }

    /**
     * @param {HTMLElement} tab
     */
    activateTab(tab) {
      this._syncState(tab);
    }

    /**
     * @param {HTMLElement} activeTab
     */
    _syncState(activeTab) {
      for (const tab of this.tabs) {
        tab.setAttribute('aria-pressed', tab === activeTab ? 'true' : 'false');
      }

      const activeControls = activeTab.getAttribute('aria-controls');
      for (const panel of this.panels) {
        if (panel.id === activeControls) {
          panel.removeAttribute('hidden');
        } else {
          panel.setAttribute('hidden', '');
        }
      }
    }

    /**
     * Arrow/Home/End roving between pills, per the ARIA toggle-group conventions.
     * @param {KeyboardEvent} event
     */
    _handleKeydown(event) {
      const idx = this.tabs.indexOf(event.currentTarget);
      const total = this.tabs.length;
      let target = null;

      switch (event.key) {
        case 'ArrowRight':
          target = this.tabs[(idx + 1) % total];
          break;
        case 'ArrowLeft':
          target = this.tabs[(idx - 1 + total) % total];
          break;
        case 'Home':
          target = this.tabs[0];
          break;
        case 'End':
          target = this.tabs[total - 1];
          break;
        default:
          return;
      }

      if (target) {
        event.preventDefault();
        this.activateTab(target);
        target.focus();
      }
    }
  }

  function initSections(root) {
    const scope = root || document;
    const sections = scope.querySelectorAll('[data-filter-life-section]');
    for (const section of sections) {
      new FilterLifeTabs(section).init();
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initSections());
  } else {
    initSections();
  }

  // Theme editor re-renders the section without a page load.
  document.addEventListener('shopify:section:load', (event) => initSections(event.target));
})();
